<template>
    <div>
        <template v-if="hearingsWidgetData">

            <div class="mb-2 w-100">
                <b-link disabled href="" class="btn border-secondary w-100 font-weight-bold">
                    <span class="text-primary font-weight-bold">Total hearings: </span> {{ hearingsWidgetData.totalSittings }}
                </b-link>
            </div>

            <div class="mb-2 w-100">
                <b-link disabled href="" class="btn border-primary w-100">
                    <span class="">Hybrid hearings: </span> {{ hearingsWidgetData.totalHybridSittings }}
                </b-link>
            </div>
            <div class="mb-2 w-100">
                <b-link disabled href="" class="btn border-primary bg-light w-100">
                    <span class="">Remote hearings: </span> {{ hearingsWidgetData.totalVideoSittings }}
                </b-link>
            </div>
            <div class="mb-2 w-100">
                <b-link disabled class="btn border-primary w-100">
                    <span class="">On-site hearings: </span> {{ hearingsWidgetData.totalOnSiteSittings }}
                </b-link>
            </div>

        </template>
        <b-modal v-model="modalVisible" title="Settings" @ok="handleModalOk">
            <b-form-group label="Title" label-for="widgetTitle">
                <b-form-input name="widgetTitle" v-model="widgetTitle"></b-form-input>
            </b-form-group>

            <b-form-group label="Court/Tribunal/Other"
                          label-for="courtRegistryId">
                <select2 name="courtRegistryId"
                         :options="allCourtRegistries"
                         multiple
                         key-property="courtRegistryId"
                         text-property="name"
                         v-model="currentConfiguration.courtRegistryIds">
                </select2>
            </b-form-group>
            <b-form-group label="Organisation"
                          label-for="interviewOrganisatoinId">
                <select2 name="interviewOrganisatoinId"
                         :options="allInterviewOrganisations"
                         multiple
                         key-property="interviewOrganisationId"
                         text-property="name"
                         v-model="currentConfiguration.interviewOrganisationIds">
                </select2>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';
    import Select2 from '../../Select2';
    import ErrorsMixin from '../../../mixins/ErrorsMixin';

    import Visibility from 'visibilityjs';

    Vue.use(BootstrapVue);
    Vue.component('select2', Select2);
    export default {
        name: 'HearingsWidget',
        mixins: [ErrorsMixin],
        props: {
            dashboardWidgetConfigurationId: {
                type: String,
                default: null
            },
            title: {
                type: String,
                default: null
            },
            configuration: {
                type: Object,
                default: null
            },
            widgetMode: {
                type: String,
                default: 'view'
            },
            selectedTimeRange: {
                type: Number,
                required: true
            }
        },
        data: function () {
            return {
                hearingsWidgetData: null,
                timer: null,
                refreshIntervalInMilliseconds: 60000,
                modalVisible: false,
                widgetTitle: this.title,
                
                currentConfiguration: this.configuration ? this.configuration : { courtRegistryIds: null, interviewOrganisationIds: null },
                allCourtRegistries: null,
                allInterviewOrganisations: null
            }
        },
        watch: {
            selectedTimeRange: function() {
                this.reloadData();
            }
        },

        methods: {
            handleModalOk() {
                this.modalVisible = false;
                this.$emit('configurationChanged', this.widgetTitle, this.currentConfiguration);
            },
            loadData: function () {
                if (this.dashboardWidgetConfigurationId) {
                    var url = this.$urlHelper.getApiUrl('dashboardwidget', 'data', ['sittings', this.dashboardWidgetConfigurationId, this.selectedTimeRange]);
                    axios
                        .get(url)
                        .then(response => {
                            this.hearingsWidgetData = response.data;
                        })
                        .catch(ex => {
                            var currentErrors = this.handleAxiosException(ex);
                            this.showErrorsToast(currentErrors);
                        });
                }
            },
            editConfiguration: function () {
                if ((this.allCourtRegistries == null) && (this.allInterviewOrganisations == null)) {
                    var promises = [];
                    var url = this.$urlHelper.getApiUrl('courtregistry', 'all');
                    promises.push(
                        axios
                            .get(url)
                            .then(response => {
                                this.allCourtRegistries = response.data;

                            }));
                    url = this.$urlHelper.getApiUrl('intervieworganisation', 'all');
                    promises.push(
                        axios
                            .get(url)
                            .then(response => {
                                this.allInterviewOrganisations = response.data;
                            }));
                    Promise
                        .all(promises)
                        .then(() => {
                            this.modalVisible = true;
                        });
                } else {
                    this.modalVisible = true;
                }
            },

            reloadData: function () {
                if (this.widgetMode == 'view') {
                    this.loadData();
                }
            },
        },
        
        mounted: function () {
            this.loadData();
            this.timer = Visibility.every(this.refreshIntervalInMilliseconds, this.reloadData);
        }
    }
</script>
